// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2457":"31d6cfe0","7382":"467b5143"}[chunkId] + ".chunk.css";
};